/** @format */

import React, { useState } from "react";
import { Form, Formik } from "formik";
import FormControl from "../forms/FormControl";
import { MdCancel } from "react-icons/md";
import * as Yup from "yup";
import Button from "../component/Button";
import { FaSpinner } from "react-icons/fa";
import { useAuth } from "../context/AuthContext";
import { doc, updateDoc, db } from "../firebase/utils";
import useStorage from "../hooks/useStorage";

function EditForm({ setCreateForm, setEditMode, editContent }) {
  //WE DESTRUCTURE THE CURRENT USER I.E CURRENTLY LOGGED IN USER & PROFILE PIC DATA "profilePic" WHICH WILL BE PASSED AS AN ARGUEMENT TO THE USE STORAGE HOOK... FROM USEAUTH
  const { profilePic, currentUser } = useAuth();
  const { url } = useStorage(profilePic);

  const docRef = doc(
    db,
    "users",
    currentUser?.uid,
    "students",
    editContent?.id
  );

  const handleCloseEditForm = () => {
    setEditMode(null);
    setCreateForm(false);
  };

  const selectClass = [
    {
      key: "Select Class",
      value: "",
    },
    {
      key: "JSS 1",
      value: "JSS 1",
    },
    { key: "JSS 2", value: "JSS 2" },
    { key: "JSS 3", value: "JSS 3" },
    { key: "SS 1", value: "SS 1" },
    { key: "SS 2", value: "SS 2" },
    { key: "SS 3", value: "SS 3" },
  ];

  //INITIAL VALUES FOR FORMIK LIB
  const initialValues = {
    firstName: editContent.firstName,
    lastName: editContent.lastName,
    otherName: editContent.otherName,
    email: editContent.email,
    age: editContent.age,
    selectClass: editContent.selectClass,
    profileImage: editContent.url, //profileImage
  };

  //YUP VALIDATION SCEHEMA

  const validationSchema = Yup.object({
    firstName: Yup.string().required("Required"),
    lastName: Yup.string().required("Required"),
    email: Yup.string().email().required("Required"),
    age: Yup.string().required("Required"),
    selectClass: Yup.mixed().required("Required"),
  });

  const onSubmit = (values, submitPros) => {
    const { resetForm, setIsSubmitting } = submitPros;
    const { otherName, firstName, lastName, email, age, selectClass } = values;

    console.log(values, values.url);
    updateDoc(docRef, {
      firstName,
      lastName,
      otherName,
      email,
      age,
      selectClass,
      url,
    })
      .then(() => {
        resetForm();
        setEditMode(null);
        setCreateForm(false);
      })
      .catch((err) => {
        console.log(err.message);
        setIsSubmitting(false);
      });
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      {(formik) => {
        return (
          <Form className="form">
            <div className="form__title--container">
              <h2>EDIT PROFILE</h2>
              <MdCancel
                onClick={handleCloseEditForm}
                style={{ color: "rgb(202,8,8)", fontSize: "1.2rem" }}
              />
            </div>

            <hr />
            <FormControl
              control="input"
              name="firstName"
              label="First Name"
              placeholder="kindly input student's first name"
              type="text"
              required
            />
            <FormControl
              control="input"
              name="lastName"
              label="Last Name"
              placeholder="kindly input student's last name"
              type="text"
              required
            />
            <FormControl
              control="input"
              name="otherName"
              label="Other Name"
              placeholder="kindly input student's other/middle name"
              type="text"
            />

            <FormControl
              control="input"
              name="email"
              label="Email"
              placeholder="please enter email"
              type="text"
              required
            />

            <FormControl
              control="input"
              name="age"
              label="Date of Birth"
              type="date"
              required
            />

            <FormControl
              control="select"
              name="selectClass"
              label="Select Class"
              type="select"
              options={selectClass}
              required
            />

            <FormControl
              control="file"
              name="profileImage"
              type="file"
              label="kindly upload a profile picture of your child/ward"
              required
            />

            <div className="submit__button">
              <Button
                btnText={
                  formik.isSubmitting ? (
                    <FaSpinner className="spinner"></FaSpinner>
                  ) : (
                    "Submit Update"
                  )
                }
                color="#fff"
                type="submit"
                bg="gold"
                btnBlock
                disabled={!formik.isValid || formik.isSubmitting}
              />
              {!formik.isValid && (
                <small
                  style={{
                    color: "red",
                    display: "block",
                    textAlign: "center",
                  }}
                >
                  kindly fill all required fields...
                </small>
              )}
            </div>
          </Form>
        );
      }}
    </Formik>
  );
}

export default EditForm;
